import { render } from "./ConnectWallet.vue?vue&type=template&id=130129fb"
import script from "./ConnectWallet.vue?vue&type=script&lang=js"
export * from "./ConnectWallet.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Proyectos\\Crypto\\dex\\github\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__